module.exports = __webpack_public_path__ + "static/img/sgzx.4ca1db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sgzx.png
// module id = xuUb
// module chunks = 0